import { render, staticRenderFns } from "./McontactoFormHeader.vue?vue&type=template&id=20d52440"
import script from "./McontactoFormHeader.vue?vue&type=script&lang=js"
export * from "./McontactoFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports